import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RewardMenu = () => {
  const [button, setButton] = useState('');
  useEffect(() => {
    if (!button) {
      setButton(window.location.pathname.split('/').slice(-1).pop());
    }
  }, [button]);

  const params = new URLSearchParams(window.location.search);
  let mobile = '';
  if (params.get('mobile')) {
    mobile = '?mobile=true';
  }

  return (
    <div className="rewards-nav">
      <div className="buttons">
        <Link to={`/main/rewards${mobile}`}>
          <button type="button" value="" className={button === 'rewards' ? 'active btn' : 'btn'}>
            <FontAwesomeIcon icon={['fas', 'home']} />
            {i18n.translate('rewards.menu.home')}
          </button>
        </Link>
        <Link to={`/main/rewards/achievements${mobile}`}>
          <button type="button" value="dashboard" className={button === 'achievements' ? 'active btn' : 'btn'}>
            <FontAwesomeIcon icon={['fas', 'bars']} />
            {i18n.translate('rewards.menu.achievements')}
          </button>
        </Link>
        <Link to={`/main/rewards/dashboard${mobile}`}>
          <button type="button" value="dashboard" className={button === 'dashboard' ? 'active btn' : 'btn'}>
            <FontAwesomeIcon icon={['far', 'badge']} />
            {i18n.translate('rewards.menu.bookings')}
          </button>
        </Link>
        <Link to={`/main/rewards/form${mobile}`}>
          <button type="button" value="form" className={button === 'form' ? 'active btn' : 'btn'}>
            <FontAwesomeIcon icon={['fas', 'upload']} />
            {i18n.translate('rewards.menu.form')}
          </button>
        </Link>
      </div>
    </div>
  );
};

export default RewardMenu;
